export default __webpack_public_path__ + "static/media/logo_malt.850bedb9.webp";